import { ColumnConfig } from '../hooks/useTablePreferences';

export const diagnosisTypeColumns: ColumnConfig[] = [
  { key: 'name', label: 'Name', defaultWidth: 320, minWidth: 150, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'createdAt', label: 'Created', defaultWidth: 130, minWidth: 100, visible: true, sortable: true, resizable: true, draggable: true },
  { key: 'updatedAt', label: 'Updated', defaultWidth: 130, minWidth: 100, visible: true, sortable: true, resizable: true, draggable: true },
];
